<p-toolbar styleClass="wd-menu-top-show" (contextmenu)="onContextMenu($event)" (press)="onContextMenu($any($event))">
  <div class="p-toolbar-group-left" [ngClass]="isDashboardVisible ? 'active' : ''">
    <button
      [ngClass]="[isDashboardVisible ? 'active' : '', 'workspace', 'p-button']"
      (click)="swapToDashBoard()"
      iuKeybinding
      [iuKeybinding-active]="true"
      iuKeybinding-code="menu-top.dashboard"
      data-cy="dashboard-btn">
      <i class="icon-dashboard-btn" aria-hidden="true"></i>
      <span class="dashboard-btn-title">{{ dashboardLabel }}</span>
    </button>
  </div>
  <div
    #tabsBar
    class="p-toolbar-group-center"
    (drop)="drop($event)"
    (dragover)="allowDrop($event)"
    iuKeybinding
    iuKeybinding-code="custom"
    [iuKeybinding-active]="true"
    [iuKeybinding-behavior-function]="chooseTab"
    [iuKeybinding-behavior-context]="$any(this)">
    <div
      *ngIf="!hasEnoughWidth && !isMobile"
      class="scroller scroller-left icon-back"
      (dragover)="scrollLeft($event)"
      (mousedown)="scrollLeft($event)"
      (mouseup)="stopScroll($event)"
      (dragleave)="stopScroll($event)"
      (drop)="stopScroll($event)"></div>
    <div #wrapper (wheel)="handleWheel($event)" class="wrapper">
      <ul
        id="tabsBar"
        [ngClass]="[isMobileWidth ? 'tabsBarMobile' : '', 'tabsBar']"
        iuKeybinding
        iuKeybinding-code="menu-top.close-tab"
        [iuKeybinding-active]="true"
        [iuKeybinding-badge-active]="false"
        [iuKeybinding-behavior-function]="handleKeybind"
        [iuKeybinding-behavior-context]="$any(this)">
        <ng-template #tabContainer> </ng-template>
      </ul>
    </div>
    <div
      *ngIf="!hasEnoughWidth && !isMobileWidth"
      class="scroller scroller-right icon-next"
      (dragover)="scrollRight($event)"
      (mousedown)="scrollRight($event)"
      (mouseup)="stopScroll($event)"
      (dragleave)="stopScroll($event)"
      (drop)="stopScroll($event)"></div>
  </div>
  <div class="p-toolbar-group-right">
    <button
      pButton
      class="p-button"
      tooltipPosition="bottom"
      (click)="showSearchContainer = !showSearchContainer; $event.stopPropagation()"
      [life]="3000"
      [hideDelay]="250"
      pTooltip="{{ 'menuTop.search' | translate }}"
      icon="icon-search-bolder"
      iuKeybinding
      [iuKeybinding-active]="true"
      iuKeybinding-code="menu-top.usearch"
      [iuKeybinding-shift]="true"
      data-cy="search-container-btn"></button>
    <button
      pButton
      [ngClass]="[nbNotifications > 0 ? 'has-notif' : 'no-notif', 'notif', 'p-button']"
      tooltipPosition="bottom"
      [life]="3000"
      [hideDelay]="250"
      pTooltip="{{ 'menuTop.notif' | translate }}"
      label="{{ nbNotifications }}"
      (click)="toggleNotificationCenter($event)"
      iuKeybinding
      [iuKeybinding-active]="true"
      iuKeybinding-code="menu-top.notifications"
      [iuKeybinding-shift]="true"
      data-cy="notification-center-btn">
      <span class="pin"></span>
    </button>
    <button
      pButton
      class="p-button"
      tooltipPosition="bottom"
      [life]="3000"
      [hideDelay]="250"
      pTooltip="{{ 'menuTop.menus' | translate }}"
      icon="icon-menu-bars"
      (click)="toggleMenu($event); isMenuDisplay ? menu.display($event) : ''"
      iuKeybinding
      [iuKeybinding-active]="true"
      iuKeybinding-code="menu-top.menu-ui"
      data-cy="main-menu-btn"></button>
    <button
      pButton
      class="p-button"
      class="userProfileButton"
      [life]="3000"
      [hideDelay]="250"
      pTooltip="{{ 'menuTop.profile' | translate }}"
      tooltipPosition="bottom"
      label="{{ connectorService.getIupicsUserAccount().fullname | textLimit: 15 }} "
      icon=" {{ overlayPanel.overlayVisible ? 'icon-up' : 'icon-open' }}"
      (click)="toggleProfile($event)"
      iconPos="right"
      iuKeybinding
      [iuKeybinding-active]="true"
      iuKeybinding-code="menu-top.profile"
      data-cy="user-profile-btn"></button>
  </div>
</p-toolbar>

<iu-prime-overlay #overlayPanel class="userProfile" [appendTo]="null" [fixedZIndex]="true">
  <iu-user-profile
    #userProfile
    [nbTabs]="components.length"
    [overlayPanel]="$any(overlayPanel)"
    (logoutEmitter)="logout($event)"
    (changeRoleEmitter)="changeRole($event)"></iu-user-profile>
</iu-prime-overlay>

<p-sidebar
  [(visible)]="showSearchContainer"
  [baseZIndex]="6000"
  [showCloseIcon]="false"
  position="top"
  class="search-container"
  styleClass="p-sidebar-md"
  data-cy="search-container">
  <iu-usearch-container
    *ngIf="showSearchContainer"
    (openTargetSearch)="this.openTargetSearch.emit($event); showSearchContainer = false"
    (closeSearch)="showSearchContainer = false"></iu-usearch-container>
</p-sidebar>

<p-sidebar
  [(visible)]="isNotificationCenterDisplay"
  [baseZIndex]="6000"
  position="right"
  [styleClass]="(isMobile || isMobileWidth ? 'iu-fullscreen-sidebar' : 'p-sidebar-md') + ' notification-center-sidebar'"
  data-cy="notification-center">
  <iu-notification-center-ui
    (toggleNotifCenter)="toggleNotificationCenter($event)"
    (updateNbNotification)="updateNbNotification($event)"></iu-notification-center-ui>
</p-sidebar>

<p-sidebar
  [(visible)]="isMenuDisplay"
  [baseZIndex]="7000"
  position="right"
  [styleClass]="isMobile || isMobileWidth ? 'iu-fullscreen-sidebar' : 'iu-big-sidebar' + ' main-menu-sidebar'"
  data-cy="main-menu">
  <iu-menu-ui
    #menu
    (createTabEmitter)="createTab($event)"
    (closeEmitter)="isMenuDisplay = $event"
    [opened]="isMenuDisplay"></iu-menu-ui>
</p-sidebar>
